const $ = require('jquery');
const cookieBannerInit = function () {
  const cookieBannerInitClosed = $.cookie('cookie_banner_closed');
  if (!cookieBannerInitClosed) {
    $('.cookie-banner__wrapper').removeClass('hidden');
  }

  $('.cookie-banner__close').click(function () {
    $('.cookie-banner__wrapper').addClass('hidden');
    $.cookie('cookie_banner_closed', 'true', { path: '/', expires: 30 });
  });
  $(".cookie-banner__more").click(function () {
    $(".cookie-banner__text-first").addClass('hidden');
    $(".cookie-banner__text-second").removeClass('hidden');
  })
};

export { cookieBannerInit };
